import { EndDate, StartDate } from '@src/component/DatePicker';
import React from 'react';
import RemittanceMoreFilter from './RemittanceMoreFilter';
import MultiSelect from '../../src/common/MultiSelect';
import { useLanguage } from "../../src/context/LanguageContext";
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';

const RemittanceListFilter: React.FC<any> = ({ config, partnerList, submitHandler, selectedFilters, setSelectedFilters,assignUsers }) => {
    const {translations} = useLanguage();
    const handleChange = (selectedOption: any, key: string) => {
        setSelectedFilters((prev: any) => {
            let updatedFilters = { ...prev };
            if (key === 'searchKeyword') {
                updatedFilters[key] = selectedOption.target.value;
            } else if (key === 'start_date' || key === 'end_date') {
                if (selectedOption.length === 2) {
                    updatedFilters[`${key}_from`] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
                    updatedFilters[`${key}_to`] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
                } else {
                    updatedFilters[`${key}_from`] = selectedOption[0]?.format("YYYY-MM-DD");
                    updatedFilters[`${key}_to`] = null;
                }
            }else if (selectedOption instanceof Array) {
                // For multi-select (array of options)
                updatedFilters[key] = selectedOption.map((e) => e.value);
            } else {
                // For single select
                updatedFilters[key] = selectedOption?.value || null;
            }
            return updatedFilters;
        });
    };
    const filterConfig = filters.remittanceFilters(translations)
    // console.log("filterConfig===>",filterConfig);
    return (
        <div className="lead-list-filter">
            <div className="filter-filed-form filter-left-panel">
                {filterConfig.map((filter: any) => renderFilterField(filter, { selectedFilters, handleChange, translations, 
                    options:{
                        partnerList,
                        lead_types: config?.lead_types,
                    }
                }))}
                {/* <fieldset className="search-bx">
                    <div className="material">
                        <input
                            type="text"
                            placeholder={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SEARCH_BY'] || translations.commonMsg?.loading}
                            name="search"
                            className="form-input"
                            title={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SEARCH_BY'] || translations.commonMsg?.loading}
                            aria-label="Policy No/Insurance ID"
                            onChange={(e) => handleChange(e, 'searchKeyword')} value={selectedFilters?.searchKeyword || ""}
                        />
                        <i className="ic-search"></i>
                    </div>
                </fieldset>

                <fieldset className="date-filed">
                    <div className="material">
                        <StartDate placeholder={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['POLICY_EFFECTIVITY_DATE'] || translations.commonMsg?.loading} selectedFilters={selectedFilters} handleChange={handleChange} />
                    </div>
                </fieldset>

                <fieldset className="date-filed">
                    <div className="material">
                        <EndDate selectedFilters={selectedFilters} handleChange={handleChange} />
                    </div>
                </fieldset>

                <fieldset className="single-select">
                     <fieldset className="single-select">
                <div className="material">
                  <MultiSelect
                        isSelectAll={true}
                        options={partnerList}
                        placeholder={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['INSURER_NAME'] || translations.commonMsg?.loading}
                        value={
                            Array.isArray(selectedFilters?.insured_name)
                            ? partnerList.filter((option: any) =>
                                selectedFilters.insured_name.includes(option.value)
                                )
                            : []
                        }
                        onChange={(e: any) => handleChange(e, 'insured_name')}
                        className="react-select"
                        classNamePrefix="react-select"
                    />
                </div>
              </fieldset>
                </fieldset> */}
            </div>

            <div className="more-filter">
                <RemittanceMoreFilter config={config} submitHandler={submitHandler} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} assignUsers={assignUsers}/>
            </div>
        </div>
    );
};

export default RemittanceListFilter;